import React, { ReactNode } from 'react';
import styles from './NotOnlyFlats.module.css';
import { Link } from 'react-router-dom';
import { PARKING_PAGE, BUSINESS_PAGE } from '../../router/paths';
import cn from 'classnames';

type CardData = {
  link: string;
  backgroundClass: string;
  children: ReactNode;
};

const NotOnlyFlatsCard: React.FC<CardData> = ({ link, backgroundClass, children }) => {
  return (
    <div className={cn(styles.card_wrapper, styles[backgroundClass])}>
      <Link to={link} className={styles.link}>
        <div className={styles.card}>
          <h3>{children}</h3>
        </div>
      </Link>
    </div>
  );
};

export default function NotOnlyFlats() {
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.header}>Не только квартиры</h2>
      <div className={styles.cards}>
        <NotOnlyFlatsCard link={BUSINESS_PAGE} backgroundClass='commercial'>
          Коммерция
        </NotOnlyFlatsCard>
        <NotOnlyFlatsCard link={PARKING_PAGE} backgroundClass='cars'>
          Машино-места
        </NotOnlyFlatsCard>
      </div>
    </div>
  );
}
